import { render, staticRenderFns } from "./EloadProvider.vue?vue&type=template&id=2d306320"
import script from "./EloadProvider.vue?vue&type=script&lang=js"
export * from "./EloadProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports